import React, { createContext, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import ConfirmBox from '../../Components/ConfirmBox/ConfirmBox';
import Loader from './../../Components/Loader/Loader';
import useCustomSnackbar from "../../helper/useCustomSnackbar";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const [confirmVisible, setConfirmVisible] = useState(false);
  // const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const showSnakbar = useCustomSnackbar()

  const login = async (token) => {
    console.log("token authContext page", token)
    setToken(token);
    localStorage.setItem("token", token);
    // navigate("/dashboard");
  };

  const handleLogout = () => {
    setLoading(true);
    setConfirmVisible(false);
    setTimeout(() => {
      setToken(null);
      localStorage.clear();
      showSnakbar('success', "Logged out successfully")
      // navigate("/");
      setLoading(false);
    }, 2000);
  };

  const cancelLogout = () => {
    setConfirmVisible(false);
  };

  const confirmLogout = () => {
    setConfirmVisible(true)
  };

  const isAuthenticated = () => !!token;
  console.log("isAuthenticated==>", isAuthenticated)

  return (
    <AuthContext.Provider
      value={{ token, login, confirmLogout, isAuthenticated }}
    >
      {children}
      <ConfirmBox
        visible={confirmVisible}
        onConfirm={handleLogout}
        onCancel={cancelLogout}

      />
      {loading && <Loader size='large' />}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
